import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { BarChart } from '@mui/x-charts';
import React, { useEffect } from 'react';
import { getReleaseTopicStatusInsights } from '../../services/ReleaseTopics';
import { useParams } from 'react-router-dom';
import {  DashboardChartIconGoodColumnTable, DashboardChartIconWarningColumnTable, DashboardChartTable, DashboardStatusLayout } from './styles/Style';
import { BackdropSkeletonComponent } from '../shared-components/backdrop/Backdrop';
import { COLOR_RED_PRIMARY, COLOR_THEME_BLUE_PRIMARY } from '../../styles/values/Colors';
import WarningIcon from '@mui/icons-material/Warning';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
interface ReleaseTopicInsights {
  completedCount: number | undefined;
  createdCount: number | undefined;
  totalTopicsRecalledCount: number | undefined;
  totalTopicsBreachedCount: number | undefined;
  totalTopicsFreezedCount: number | undefined;
  totalTopicsCount: number | undefined;
  totalTopicsGroomingCount: number | undefined;
}
export default function ReleaseTopicCharts() {
  const { projectId = '' } = useParams();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [releaseTopicInsights, setReleaseTopicInsights] = React.useState<ReleaseTopicInsights>();
  const getReleaseTopicInsights = async () => {
    const result = await getReleaseTopicStatusInsights(projectId);
    setReleaseTopicInsights(result.data);
  };
  useEffect(() => {
    setLoading(true);
    getReleaseTopicInsights();
    setLoading(false);
  }, []);
  return (
    <BackdropSkeletonComponent
      loading={loading}
      sx={{ display: 'flex', justifyContent: 'center', height: '700px', width: '40%' }}
    >
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid>
          <Paper elevation={3} sx={DashboardStatusLayout}>
            <BarChart
              xAxis={[
                {
                  id: 'release-topics',
                  data: ['Created', 'Grooming', 'Completed', 're-called', 'Breached', 'Freezed', 'Total No.of Topics'],
                  scaleType: 'band',
                },
              ]}
              colors={[
                COLOR_THEME_BLUE_PRIMARY,
                COLOR_THEME_BLUE_PRIMARY,
                COLOR_THEME_BLUE_PRIMARY,
                COLOR_RED_PRIMARY,
                COLOR_RED_PRIMARY,
                COLOR_THEME_BLUE_PRIMARY,
                COLOR_THEME_BLUE_PRIMARY,
              ]}
              series={[
                {
                  data: [
                    releaseTopicInsights?.createdCount || 0,
                    releaseTopicInsights?.totalTopicsGroomingCount || 0,
                    releaseTopicInsights?.completedCount || 0,
                    releaseTopicInsights?.totalTopicsRecalledCount || 0,
                    releaseTopicInsights?.totalTopicsBreachedCount || 0,
                    releaseTopicInsights?.totalTopicsFreezedCount || 0,
                    releaseTopicInsights?.totalTopicsCount || 0,
                  ],
                },
              ]}
              height={400}
              width={700}
            />
          </Paper>
        </Grid>
        <Grid>
          <Box sx={{ padding: 1, height: '400px', width: '400px' }}>
            <TableContainer sx={{ width: '100%', scrollBehavior: 'auto' }} component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontSize: 25 }} colSpan={3}>
                      <strong>Insights ({`${releaseTopicInsights?.totalTopicsCount || 0}`})</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow key={0}>
                    <TableCell width={'10%'} sx={DashboardChartIconGoodColumnTable}>
                      <ThumbUpAltIcon />
                    </TableCell>
                    <TableCell sx={DashboardChartTable}>Created</TableCell>
                    <TableCell> {`${releaseTopicInsights?.createdCount || 0}`}</TableCell>
                  </TableRow>
                  <TableRow key={0}>
                    <TableCell width={'10%'} sx={DashboardChartIconGoodColumnTable}>
                      <ThumbUpAltIcon />
                    </TableCell>
                    <TableCell sx={DashboardChartTable}>Grooming</TableCell>
                    <TableCell> {`${releaseTopicInsights?.totalTopicsGroomingCount || 0}`}</TableCell>
                  </TableRow>
                  <TableRow key={0}>
                    <TableCell width={'10%'} sx={DashboardChartIconGoodColumnTable}>
                      <ThumbUpAltIcon />
                    </TableCell>
                    <TableCell sx={DashboardChartTable}>Completed</TableCell>
                    <TableCell> {`${releaseTopicInsights?.completedCount || 0}`}</TableCell>
                  </TableRow>
                  <TableRow key={0}>
                    <TableCell width={'10%'} sx={DashboardChartIconWarningColumnTable}>
                      <WarningIcon />
                    </TableCell>
                    <TableCell sx={DashboardChartTable}>Recalled</TableCell>
                    <TableCell> {`${releaseTopicInsights?.totalTopicsRecalledCount || 0}`}</TableCell>
                  </TableRow>
                  <TableRow key={0}>
                    <TableCell width={'10%'} sx={DashboardChartIconWarningColumnTable}>
                      <WarningIcon />
                    </TableCell>
                    <TableCell sx={DashboardChartTable}>Breached</TableCell>
                    <TableCell> {`${releaseTopicInsights?.totalTopicsBreachedCount || 0}`}</TableCell>
                  </TableRow>
                  <TableRow key={0}>
                    <TableCell width={'10%'} sx={DashboardChartIconGoodColumnTable}>
                      <ThumbUpAltIcon />
                    </TableCell>
                    <TableCell sx={DashboardChartTable}>Freezed</TableCell>
                    <TableCell> {`${releaseTopicInsights?.totalTopicsFreezedCount || 0}`}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </BackdropSkeletonComponent>
  );
}
